import { createTheme } from '@mui/material/styles';
import { PaletteOptions } from '@mui/material/styles/createPalette';
import { ThemeOptions } from '@mui/material/styles/createTheme';

interface CustomPaletteOptions extends PaletteOptions {
    customColor?: {
        main: string;
        secondary: string;
    };
}

const theme = createTheme({
    // Customize your theme options here
    palette: {
        primary: {
            main: '#3f51b5',
        },
        secondary: {
            main: '#f50057',
        },
        customColor: {
            main: '#00bcd4',
            secondary: '#ff9800',
        },
    },
} as ThemeOptions & { palette: CustomPaletteOptions });

export default theme;